import Http from '@/api/http-v2.js'

export default {
  // Métodos específicos para v2
  index(type, filter) {
    return Http.get(`/${type}`, {params: {...filter}})
  },
  
  show(params) {
    return Http.get(`/${params.type}/${params.id}`)
  },

  // Método específico para produtos com brand_id
  getProducts(brand_id) {
    return Http.get('/products', {params: {brand_id}})
  },

  // Método específico para pickup_locations com brand_id
  getPickupLocations(brand_id) {
    return Http.get('/pickup_locations', {params: {brand_id}})
  },

  create(type, data) {
    console.log('create',type, data)
    return Http.post(`/${type}`, data)
  },

  update(type, data) {
    console.log('update',type, data)
    return Http.put(`/${type}/${data.id}`, data)
  },
  
}

